<div class="page gray-font-color font-family" data-test="upload-document" data-testid="dqf-upload-page">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-test="back-arrow-icon" data-testid="back-arrow-icon">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text" data-testid="dqf-upload-header">{{ heading }}</div>
  </div>
  @if (loading) {
    <app-loading-gif></app-loading-gif>
  }
  @if (!loading) {
    <div class="content">
      @if (showStatus) {
        <div class="status" [ngClass]="!currentSelectedData?.id ? 'pending' : 'complete'">
          <div class="info">
            <p>{{ currentStatus }}</p>
          </div>
          <div class="cross-icon" (click)="closeNotification()"><mat-icon svgIcon="crossed"> </mat-icon></div>
        </div>
      }
      <div class="documents-list-container">
        <div class="documents-list">
          @for (doc of documents; track doc) {
            <div class="document-item" (click)="doc.clickHandler ? doc.clickHandler(doc) : null" [ngClass]="getStatusClass(doc)" [attr.data-testid]="'dqf-upload-' + (doc.displayName | lowercase)">
              <div class="document-icon-wrapper">
                <mat-icon class="document-icon" [svgIcon]="getDocumentIcon(doc)"></mat-icon>
              </div>
              <div class="document-info">
                <h3 class="document-title" [attr.data-testid]="'dqf-upload-name-' + (doc.displayName | lowercase)">{{ doc.displayName }}</h3>
                <p class="document-status" [attr.data-testid]="'dqf-upload-status-' + (doc.displayName | lowercase)">{{ getStatusText(doc) }}</p>
              </div>
              <div class="status-indicator">
                <mat-icon class="status-icon">{{ getStatusIcon(doc) }}</mat-icon>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
